import { createApp, nextTick } from 'vue'
import { createPinia } from 'pinia'

import './assets/main.css'
import App from './App.vue'
import router from './router'
import  {requestNotificationPermission} from './configFirebase.js'
const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(router)
app.mount('#app')
router.afterEach((to, from) => {
	if (to.name === "dashboard") {
	nextTick(async () => {
		try {
			// Kiểm tra token trong localStorage
			const token = localStorage.getItem("token");
			const isAuthenticated = !!token; // Chuyển token thành boolean

			if(isAuthenticated){
				const firebaseToken = await requestNotificationPermission();
			}
			
		} catch (error) {
			console.error('Failed to update Firebase token:', error);
		}
		});
	}
});
